<template>
  <div>
    <HistoryInfoBoxes :detail="info">
      <template #box0>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('stock-adjust.stock-adjust_adjustment-date') }}：
          </v-col>
          <v-col>{{ items.stockAdjustDate }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('common.common_inventory-adjustment-number') }}
          </v-col>
          <v-col>{{ nullEmptyFormat(items.transaction.controlNumber) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('ship.ship_tracking-number') }}： </v-col>
          <v-col>{{ nullEmptyFormat(items.trackingNumber) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('stock-adjust.stock-adjust_inventory-adjustment-reason') }}：
          </v-col>
          <v-col>{{ getAdjustReason(items.adjustReasonId) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
            >{{ $t('stock-adjust.stock-adjust_presentation-target') }}：
          </v-col>
          <v-col>{{ nullEmptyFormat(items.target) }} </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3">{{ $t('common.input_remarks') }}： </v-col>
          <v-col
            >{{
              nullEmptyFormat(
                items.stockAdjustNote && items.stockAdjustNote.body
              )
            }}
          </v-col>
        </v-row>
      </template>
      <template #box1>
        <v-row no-gutters>
          <v-col class="mb-1 font-weight-bold nameText"
            >{{ nullEmptyFormat(items.recipientName) + $t('sale.sale_mr') }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            >{{
              getDisplayPostalCode(
                getCountryName(items.recipientCountryId),
                getPostalCode(
                  items.recipientPostalCode,
                  items.recipientCountryId
                )
              )
            }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col
            >{{
              nullEmptyFormat(
                getRegionName(items.recipientCountryId, items.recipientRegionId)
              ) +
              nullEmptyFormat(items.recipientAddress1) +
              nullEmptyFormat(items.recipientAddress2)
            }}
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="2">{{ $t('common.input_phone-number') }}： </v-col>
          <v-col
            >{{
              nullEmptyFormat(
                getPhoneNumber(
                  items.recipientPhoneNumber,
                  items.recipientPhoneNumberCountryId
                )
              )
            }}
          </v-col>
        </v-row>
      </template>
    </HistoryInfoBoxes>
  </div>
</template>
<script>
import HistoryInfoBoxes from '@/components/items/Designs/HistoryInfoBoxes'
import {
  commonUtil,
  countryUtil,
  countryCallingCodeUtil,
  stockAdjustUtil
} from '@/util'

export default {
  components: { HistoryInfoBoxes },
  props: {
    items: { default: {} }
  },
  data: () => ({
    info: []
  }),
  created() {
    this.info = this.createList()
  },
  methods: {
    createList() {
      const shipInfo = {
        ...this.interfaceObj,
        title: 'ship.ship_ship-info'
      }
      const destinationInfo = {
        ...this.interfaceObj,
        title: 'ship.ship_ship-dest-info'
      }

      return [shipInfo, destinationInfo]
    },
    getCountryName(id) {
      const country = countryUtil.findCountryId(id)
      return country ? country.name : ''
    },
    getRegionName(countryId, regionId) {
      return countryUtil.getRegionInfo(countryId, regionId).label
    },
    getPhoneNumber(phone, callingCode) {
      return countryCallingCodeUtil.formatPhoneNumber(phone, callingCode)
    },
    getPostalCode(postalCode, countryId) {
      return commonUtil.formatPostalCode(postalCode, countryId)
    },
    getDisplayPostalCode(country, postalCode) {
      if (country && postalCode) return country + ' ' + postalCode
      return this.nullEmptyFormat(country) + this.nullEmptyFormat(postalCode)
    },
    getAdjustReason(id) {
      return stockAdjustUtil.getAdjustReasonById(id).name
    },
    nullEmptyFormat(str) {
      return commonUtil.nullEmptyFormat(str, '')
    }
  },
  computed: {}
}
</script>
<style lang="scss" scoped>
.nameText {
  font-size: 14px;
}
</style>
